var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermanentlyDeleteAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FEF1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5V15M15 17.5H15.0063M9.375 15C9.375 15.7387 9.52049 16.4701 9.80318 17.1526C10.0859 17.8351 10.5002 18.4551 11.0225 18.9775C11.5449 19.4998 12.1649 19.9141 12.8474 20.1968C13.5299 20.4795 14.2613 20.625 15 20.625C15.7387 20.625 16.4701 20.4795 17.1526 20.1968C17.8351 19.9141 18.4551 19.4998 18.9775 18.9775C19.4998 18.4551 19.9141 17.8351 20.1968 17.1526C20.4795 16.4701 20.625 15.7387 20.625 15C20.625 13.5082 20.0324 12.0774 18.9775 11.0225C17.9226 9.96763 16.4918 9.375 15 9.375C13.5082 9.375 12.0774 9.96763 11.0225 11.0225C9.96763 12.0774 9.375 13.5082 9.375 15Z",
    stroke: "url(#paint0_linear_1493_9008)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1493_9008",
    x1: 9.375,
    y1: 15,
    x2: 20.625,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermanentlyDeleteAccount);
export default __webpack_public_path__ + "static/media/Permanently Delete Account.fbc1ba12bb2ca8cdf89eabffe20786b6.svg";
export { ForwardRef as ReactComponent };